// extracted by mini-css-extract-plugin
module.exports = {"noMenus":"NoMenus__noMenus___1Fc0b","noMenuIcon":"NoMenus__noMenuIcon___MF9QA","primary":"NoMenus__primary___E7Stc","secondary":"NoMenus__secondary___3r9_5"};